import { Link } from 'react-router-dom';

export function IdVerificationPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <p className="text-orange font-semibold uppercase tracking-wider text-sm mb-2">
        ID verification
      </p>
      <h1 className="text-3xl md:text-4xl font-bold text-navy mb-4">
        One quick check before your first rental.
      </h1>
      <p className="text-lg text-navy-600 mb-10">
        TowShare uses <strong>Stripe Identity</strong> to verify every renter's
        government-issued ID before their first booking. It's a 60-second flow on your
        phone — and it's why owners can trust the platform.
      </p>

      <div className="space-y-6">
        <Section title="How it works">
          <ol className="list-decimal pl-5 space-y-2 text-navy-700">
            <li>You start the verification from your TowShare account.</li>
            <li>Stripe opens a secure flow on your device.</li>
            <li>You photograph your driver's license, passport, or provincial ID.</li>
            <li>You take a quick selfie. Stripe confirms it matches the ID.</li>
            <li>Verification usually clears in under a minute.</li>
          </ol>
        </Section>

        <Section title="What we accept">
          <ul className="list-disc pl-5 space-y-2 text-navy-700">
            <li>Canadian driver's license</li>
            <li>Canadian passport</li>
            <li>Provincial / territorial photo ID card</li>
            <li>Most foreign passports (for international renters)</li>
          </ul>
        </Section>

        <Section title="Your data">
          <p className="text-navy-700">
            Your ID and selfie are processed by Stripe Identity. <strong>TowShare never
            stores your documents.</strong> We only receive a yes/no signal back. Stripe
            retains the data per their{' '}
            <a
              href="https://stripe.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-orange hover:underline"
            >
              Privacy Policy
            </a>
            .
          </p>
        </Section>

        <div className="text-center pt-4">
          <Link to="/account/verify" className="btn-primary">
            Verify my ID now
          </Link>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="card p-6">
      <h2 className="text-xl font-semibold text-navy mb-3">{title}</h2>
      {children}
    </section>
  );
}
